<template>
    <div id="audit__log__listing__block">
        <div class="collapsible-heading p-0">
            <div class="d-flex bottom-border audit-log-wrapper-mobile">
                <div class="audit-log-item collapsible-heading__title" @click="onToggleExpand" :class="companyColor">
                    <strong>{{batchTitle}}</strong> by <strong>{{batchDetail.user}}</strong>
                    <span class="controls" :class="companyColorDropdownIcon">
                        <span :class="expand ? 'opened' : 'closed'" class="icon">
                            <font-awesome-icon icon="chevron-right" />
                        </span>
                    </span>
                </div>
                <div class="audit-log-item" :class="companyColor" @click="onToggleExpand">
                    <template v-for="(c,i) in companyTree">
                        {{c}} {{i == companyTree.length - 1 ? '' : '/'}} <span v-if="i == 0" class="date text-muted">{{batchDetail.time}}</span><br :key="i"/>
                    </template>
                </div>
                <div :class="companyColor" @click="onToggleExpand" v-if="adminView"><span :style="`visibility: ${batchDetail.lcrId ? 'visible' : 'hidden'};`">LCR: {{batchDetail.lcrId}}</span></div>
            </div>
        </div>
        <b-collapse id="collapseAuditListing" :visible="expand" class="collapse--content">
            <b-col @click="onToggleExpand">
                <b-row v-for="(logItem, y) in this.logsData" v-bind:key="'logitem-'+y+'-'+Math.random()">

                    <b-col class="collapse-content-wrapper">
                        <div class="lcr-summary__label">{{$t(`auditLog.laneClosureRequest.${logItem.label}`)}}</div>
                        <div v-for="line in logItem.getContent()" class="lcr-summary__value"><font-awesome-icon v-if="line.faType" :icon="line.faType" :class="'mr-2 ' + line.faType"></font-awesome-icon><span v-html="line.text"></span></div>
                    </b-col>
                </b-row>
                <b-row v-if="this.logsData.length == 0">
                    <b-col class="collapse-content-wrapper">
                        <div><h5>No changes were made.</h5></div>
                    </b-col>
                </b-row>
            </b-col>
        </b-collapse>
    </div>
</template>

<script>
import AuditLogList from '../models/AuditLogList';
import AuditLogClosure from '../models/AuditLogClosure';
import AuditLogRestriction from '../models/AuditLogRestriction';

import Format from '../utility/Format';
import LaneClosureRequest from '../models/LaneClosureRequest';
export default {
    name: 'AuditLogListingBlock',
    props: ['batchDetail', 'adminView', 'logs', 'lcr'],
    data() {
        return {
            expand: false
        }
    },
    computed: {
        logsData() {
            return new AuditLogList(this.logs, this.$t, this).getAuditFields();
        },

        logsDataClosure() {
            return new AuditLogClosure(this.logs).getContent();
        },

        logsDataRestriction() {
            return new AuditLogRestriction(this.logs).getContent();
        },

        isClosureEmpty() {
            let closure = new AuditLogClosure(this.logs).getContent();
            let empty = true;
            closure.forEach(item => {
                if (Object.values(item).length != 0) empty = false
            });
            return empty;
        },

        isRestrictionEmpty() {
            let restriction = new AuditLogRestriction(this.logs).getContent();
            let empty = true;
            restriction.forEach(item => {
                if (Object.values(item).length != 0) empty = false
            });
            return empty;
        },

        batchTitle() {
            if (!this.adminView) {
                if (this.batchDetail.auditTypeId == 1) {
                    return this.$t('auditLog.laneClosureRequest.NewRequest');
                }
                else if (this.batchDetail.auditTypeId == 2) {
                    return this.$t('auditLog.laneClosureRequest.UpdatedRequest');
                }
                else {
                    return this.batchDetail.notes;
                }
            } else {
                return this.batchDetail.notes;
            }
        },

        companyColor() {
            if (this.batchDetail.organizationType == "city") {
                return "flex-grow-1 bg-primary-x-light collapsible-heading__value color-column";
            } else {
                return "flex-grow-1 bg-secondary-light collapsible-heading__value color-column";
            }
        },
        companyColorDropdownIcon() {
            if (this.batchDetail.organizationType == "city") {
                return "bg-primary-x-light collapsible-heading__toggle";
            } else {
                return "bg-secondary-light collapsible-heading__toggle";
            }
        },
        companyTree() {
            if (this.batchDetail.organizationNamePath) {
                let path = this.batchDetail.organizationNamePath;
                path = path.split('|');
                path.pop();
                path.shift();
                return path.reverse();
            }
            return [this.batchDetail.organizationName];
        }
    },
    methods: {
        onToggleExpand() {
            this.expand = !this.expand
        },

        getTurningRestrictionName(lane) {
            return Format.searchById(lane.RestrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).name
        }
    }
}
</script>

<style>

</style>